module.exports = "pegasus/assets/themelp1/small/51.png";